import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as UsersIcon } from "../../assets/images/user.svg";
import { ReactComponent as ActiveIcon } from "../../assets/images/active_users.svg";
import { ReactComponent as ReturningIcon } from "../../assets/images/return_users.svg";
import Tooltip from "@mui/material/Tooltip";
import "./style.scss";

const CustomCard = ({ data, loading }) => {
  const kpis = [
    {
      label: "Total Users",
      value: data?.total_users || 0,
      icon: UsersIcon,
      info: "Total number of users who have access to a specific indication",
      condition: "increase",
    },
    {
      label: "Active Users",
      value: data?.active_users || 0,
      icon: ActiveIcon,
      info: "Users who have interacted with the agent within 7 days by default",
      condition: "decrease",
    },
    {
      label: "Engaged Users",
      value: Array.isArray(data?.returning_users)
        ? data.returning_users.length
        : data?.returning_users || 0,
      icon: ReturningIcon,
      info: "Users who have asked more than one question",
      condition: "increase",
    },
  ];
  return (
    <Stack
      className="cards-wrapper"
      gap={2}
      width={"100%"}
      flexShrink={0}
      direction={{ xs: "row", md: "column" }}
    >
      {kpis.map((kpi, index) => {
        return (
          <Card key={index} className="card-container">
            <CardContent>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <kpi.icon style={{ width: 25, height: 25, color: "#339CFF" }} />
                <Tooltip title={kpi.info}>
                  <InfoOutlineIcon sx={{ color: "#9ea2a9", height: "17px" }} />
                </Tooltip>
              </Stack>

              <Stack direction="row" alignItems="center" gap={2} className="kpi-value-row">
                <div className="kpi-value-box">
                  {loading ? (
                    // <CircularProgress size={20} sx={{ml:0.5 , color:"#339cff"}}/>
                    <CircularProgress size={20} sx={{ml:0.5 , color:"#002060"}}/>
                  ) : (
                    <Typography
                      color="#03070e"
                      fontSize="2rem"
                      fontWeight={600}
                      className="kpi-value-text"
                      title={String(kpi.value)} // shows full value on hover
                    >
                      {kpi.value}
                    </Typography>
                  )}</div>
              </Stack>

              <Typography className="card-label">{kpi.label}</Typography>
            </CardContent>
          </Card>
        );
      })}
    </Stack>
  );
};

export default CustomCard;
